import { useRef, useEffect } from "react";
// import { HeaderProps } from 'react-table';

// interface HeaderCheckboxProps<T extends object> extends HeaderProps<T> {}

/*
function HeaderCheckbox<T extends object>({
  getToggleAllPageRowsSelectedProps,
}: HeaderCheckboxProps<T>)
*/

function HeaderCheckbox({ getToggleAllPageRowsSelectedProps }) {
  const { indeterminate, ...rest } = getToggleAllPageRowsSelectedProps();
  const defaultRef = useRef(null);

  useEffect(() => {
    if (defaultRef.current) {
      defaultRef.current.indeterminate = !!indeterminate;
    }
  }, [defaultRef, indeterminate]);

  return (
    <div className="tw-flex tw-justify-center tw-items-center tw-h-full">
      <input
        className="tw-w-4 tw-h-4"
        id="header_checkbox"
        type="checkbox"
        {...rest}
      />
    </div>
  );
}

export default HeaderCheckbox;
